import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['ReviewsAnnotationsTags', 'ReviewsAnnotationsWords'] });

const apiReviewsAnnotationsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getReviewsAnnotations: builder.query({
      query: ({ ean, id }) => ({
        url: `/community/products/${ean}/reviews/${id}/annotations/`,
        method: 'GET',
      }),
      providesTags: ['ReviewsAnnotationsTags', 'ReviewsAnnotationsWords'],
    }),
    getReviewsAnnotationsTags: builder.query({
      query: ({ ean, rpk, ordering, page, psize }) => ({
        url: `/community/products/${ean}/reviews/${rpk}/annotations/tags/`,
        method: 'GET',
        params: {
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['ReviewsAnnotationsTags'],
    }),
    postReviewsAnnotationsTags: builder.mutation({
      query: ({ ean, rpk, payload }) => ({
        url: `/community/products/${ean}/reviews/${rpk}/annotations/tags/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ReviewsAnnotationsTags'],
    }),
  }),
});

export const { useGetReviewsAnnotationsTagsQuery, usePostReviewsAnnotationsTagsMutation } = apiReviewsAnnotationsSlice;

export default apiReviewsAnnotationsSlice;
